import React from "react";
import { CourseSchedulingTabsUnit } from "./course-scheduling-tabs-unit";

export function CourseSchedulingPage(props): JSX.Element {
  return <CourseSchedulingTabsUnit />;
}
